import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

// breakpoints 1020px

export const useStyles = makeStyles({
  desktopPlanBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '20px',
    [theme.breakpoints.down('lg')]: {
      columnGap: '10px',
    },

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },

  mobilePlanBtnWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px',
    width: 'max-content',
    border: `1px solid ${theme.palette.cinnamon.main}`,

    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },

  freeMealCountWrapper: {
    marginTop: '8px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
  },

  planAmountWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },

  planAmount: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
